import { DATE_FORMATS, formatDateToUI } from '@dealstack/shared/lib/format/dates/date.ts';

/**
 * Nominal value per unit after every split/reverse split. Falls back to the original
 * `nominalValue` when the backend had no holdings to compute it from.
 */
export const getCurrentNominalValue = (security: {
	nominalValue?: number;
	nominalValuePerUnit?: number;
}): number | undefined => security.nominalValuePerUnit || security.nominalValue;

/** The as-of date the current nominal value was computed for; no picked date means today. */
export const formatNominalValueAsOfDate = (filterDate: Date | null) =>
	formatDateToUI(filterDate ?? new Date(), DATE_FORMATS.CALENDAR_DATE);
